import React from 'react';
import { useLanguage } from './LanguageContext';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  return (
    <div className="flex items-center glass-effect rounded-full overflow-hidden border border-white/10">
      <button
        onClick={() => setLanguage('pl')}
        className={`px-3 py-1.5 text-xs font-bold transition-all ${
          language === 'pl' ? 'text-cyan-400' : 'text-gray-500 hover:text-white'
        }`}
      >
        PL
      </button>
      <div className="w-px h-4 bg-white/10" />
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-1.5 text-xs font-bold transition-all ${
          language === 'en' ? 'text-cyan-400' : 'text-gray-500 hover:text-white'
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
